<app-admin-nav />

<div class="notif-admin-container">

  <div class="page-header">
    <h1>Notificaciones</h1>
    <p class="page-subtitle">Envía notificaciones push y consulta el historial de envíos masivos.</p>
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <button class="tab-btn" [class.active]="activeTab === 'individual'" (click)="setTab('individual')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
      Individual
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'broadcast'" (click)="setTab('broadcast')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
      </svg>
      Broadcast
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'history'" (click)="setTab('history')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
      Historial de broadcasts
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'list'" (click)="setTab('list')">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
        <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
      </svg>
      Historial de notificaciones
    </button>
  </div>

  <!-- ─── BROADCAST TAB ─── -->
  @if (activeTab === 'broadcast') {
    <div class="tab-content">
      <div class="card">
        <h2>Enviar a todos los usuarios</h2>
        <p class="card-desc">
          Se enviará una notificación push a todos los usuarios que tengan las notificaciones activadas. El proceso de envío puede tardar unos minutos en completarse, dependiendo del número de usuarios.
        </p>

        @if (broadcastSuccess) {
          <div class="alert alert--success">
            ✓ Broadcast iniciado correctamente. Las notificaciones se están procesando.
          </div>
        }

        @if (broadcastError) {
          <div class="alert alert--error">{{ broadcastError }}</div>
        }

        <div class="form-group">
          <label for="bTitle">Título</label>
          <input id="bTitle" type="text" [(ngModel)]="broadcastTitle" placeholder="Título de la notificación" [disabled]="broadcastSending" />
        </div>

        <div class="form-group">
          <label for="bContent">Contenido</label>
          <div class="html-toolbar">
            <button type="button" class="html-btn" title="Negrita" [disabled]="broadcastSending" (click)="insertHtml('bContent', 'broadcastContent', '<b>', '</b>')"><b>B</b></button>
            <button type="button" class="html-btn" title="Cursiva" [disabled]="broadcastSending" (click)="insertHtml('bContent', 'broadcastContent', '<i>', '</i>')"><i>I</i></button>
            <button type="button" class="html-btn" title="Subrayado" [disabled]="broadcastSending" (click)="insertHtml('bContent', 'broadcastContent', '<u>', '</u>')"><u>U</u></button>
            <button type="button" class="html-btn" title="Enlace" [disabled]="broadcastSending" (click)="insertLink('bContent', 'broadcastContent')">&#x1F517;</button>
          </div>
          <textarea id="bContent" rows="5" [(ngModel)]="broadcastContent" placeholder="Contenido (puede incluir HTML)" [disabled]="broadcastSending"></textarea>
        </div>

        @if (broadcastContent) {
          <div class="preview">
            <span class="preview-label">Preview:</span>
            <strong>{{ broadcastTitle }}</strong>
            <p [innerHTML]="broadcastContent"></p>
          </div>
        }

        <button class="btn btn--primary btn--full" (click)="sendBroadcast()" [disabled]="broadcastSending || !broadcastTitle.trim() || !broadcastContent.trim()">
          @if (broadcastSending) {
            <span class="spinner-sm"></span> Enviando...
          } @else {
            Enviar a todos los usuarios
          }
        </button>
      </div>
    </div>
  }

  <!-- ─── INDIVIDUAL TAB ─── -->
  @if (activeTab === 'individual') {
    <div class="tab-content">
      <div class="card">
        <h2>Enviar a un usuario</h2>
        <p class="card-desc">Introduce el UID de Firebase del usuario destinatario.</p>

        @if (individualSuccess) {
          <div class="alert alert--success">
            ✓ Notificación enviada correctamente.
          </div>
        }

        @if (individualError) {
          <div class="alert alert--error">{{ individualError }}</div>
        }

        <div class="form-group autocomplete-group">
          <label for="iUserSearch">Usuario</label>
          <div class="autocomplete-input-wrap">
            <input id="iUserSearch" type="text" [(ngModel)]="userSearchQuery"
                   (ngModelChange)="onUserSearchInput()"
                   placeholder="Buscar por nombre, email o UID…"
                   autocomplete="off"
                   [disabled]="individualSending" />
            @if (userSearchLoading) {
              <span class="search-spinner"></span>
            }
          </div>
          @if (userSearchResults.length > 0) {
            <ul class="user-dropdown">
              @for (u of userSearchResults; track u.id) {
                <li (click)="selectUser(u)">
                  @if (u.name) { <span class="ud-name">{{ u.name }}</span> }
                  @if (u.email) { <span class="ud-email">{{ u.email }}</span> }
                  <span class="ud-uid">{{ u.id }}</span>
                </li>
              }
            </ul>
          }
          @if (individualUserId) {
            <div class="user-chip">
              <span class="user-chip__name">{{ userSearchQuery }}</span>
              <code class="user-chip__uid">{{ individualUserId }}</code>
              <button type="button" class="user-chip__clear" title="Deseleccionar usuario" (click)="clearSelectedUser()">&#x2715;</button>
            </div>
          }
        </div>

        <div class="form-group">
          <label for="iTitle">Título</label>
          <input id="iTitle" type="text" [(ngModel)]="individualTitle" placeholder="Título de la notificación" [disabled]="individualSending" />
        </div>

        <div class="form-group">
          <label for="iContent">Contenido</label>
          <div class="html-toolbar">
            <button type="button" class="html-btn" title="Negrita" [disabled]="individualSending" (click)="insertHtml('iContent', 'individualContent', '<b>', '</b>')"><b>B</b></button>
            <button type="button" class="html-btn" title="Cursiva" [disabled]="individualSending" (click)="insertHtml('iContent', 'individualContent', '<i>', '</i>')"><i>I</i></button>
            <button type="button" class="html-btn" title="Subrayado" [disabled]="individualSending" (click)="insertHtml('iContent', 'individualContent', '<u>', '</u>')"><u>U</u></button>
            <button type="button" class="html-btn" title="Enlace" [disabled]="individualSending" (click)="insertLink('iContent', 'individualContent')">&#x1F517;</button>
          </div>
          <textarea id="iContent" rows="5" [(ngModel)]="individualContent" placeholder="Contenido (puede incluir HTML)" [disabled]="individualSending"></textarea>
        </div>

        @if (individualContent) {
          <div class="preview">
            <span class="preview-label">Preview:</span>
            <strong>{{ individualTitle }}</strong>
            <p [innerHTML]="individualContent"></p>
          </div>
        }

        <button class="btn btn--primary btn--full" (click)="sendIndividual()" [disabled]="individualSending || !individualTitle.trim() || !individualContent.trim() || !individualUserId.trim()">
          @if (individualSending) {
            <span class="spinner-sm"></span> Enviando...
          } @else {
            Enviar notificación
          }
        </button>
      </div>
    </div>
  }

  <!-- ─── HISTORY TAB ─── -->
  @if (activeTab === 'history') {
    <div class="tab-content">

      @if (historyLoading) {
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Cargando historial...</p>
        </div>
      }

      @if (!historyLoading && historyError) {
        <div class="error-state">
          <p>Error al cargar el historial.</p>
          <button (click)="loadHistory()">Reintentar</button>
        </div>
      }

      @if (!historyLoading && !historyError) {

        <!-- Stats row -->
        <div class="kpi-grid">
          <div class="kpi-card">
            <span class="kpi-value">{{ broadcasts.length }}</span>
            <span class="kpi-label">Broadcasts enviados</span>
          </div>
          <div class="kpi-card highlight">
            <span class="kpi-value">{{ broadcasts[0]?.totalUsers ?? '—' }}</span>
            <span class="kpi-label">Usuarios en último envío</span>
          </div>
          <div class="kpi-card">
            <span class="kpi-value">{{ broadcasts[0] ? formatDate(broadcasts[0].creationDate) : '—' }}</span>
            <span class="kpi-label">Último envío</span>
          </div>
        </div>

        @if (broadcasts.length === 0) {
          <div class="empty-state">
            <p>No hay broadcasts enviados todavía.</p>
          </div>
        }

        @if (broadcasts.length > 0) {
          <div class="table-wrapper">
            <table class="history-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Título</th>
                  <th>Contenido</th>
                  <th class="text-right">Usuarios</th>
                </tr>
              </thead>
              <tbody>
                @for (b of broadcasts; track b.id) {
                  <tr>
                    <td class="date-cell">{{ formatDate(b.creationDate) }}</td>
                    <td class="title-cell">{{ b.title }}</td>
                    <td class="content-cell">{{ stripHtml(b.content) }}</td>
                    <td class="text-right users-cell">{{ b.totalUsers }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      }
    </div>
  }

  <!-- ─── NOTIFICATIONS LIST TAB ─── -->
  @if (activeTab === 'list') {
    <div class="tab-content">

      <!-- Filters -->
      <div class="filters-bar">
        <div class="filter-group">
          <label>Usuario (UID)</label>
          <input type="text" [(ngModel)]="listFilterOwner" placeholder="UID de Firebase" (keydown.enter)="applyListFilters()" />
        </div>
        <div class="filter-group">
          <label>Estado</label>
          <select [(ngModel)]="listFilterRead">
            <option value="">Todas</option>
            <option value="false">No leídas</option>
            <option value="true">Leídas</option>
          </select>
        </div>
        <div class="filter-group">
          <label>Desde</label>
          <input type="date" [(ngModel)]="listFilterFrom" />
        </div>
        <div class="filter-group">
          <label>Hasta</label>
          <input type="date" [(ngModel)]="listFilterTo" />
        </div>
        <button class="btn btn--primary" (click)="applyListFilters()">Filtrar</button>
      </div>

      <!-- Loading -->
      @if (listLoading) {
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Cargando notificaciones...</p>
        </div>
      }

      <!-- Error -->
      @if (!listLoading && listError) {
        <div class="error-state">
          <p>Error al cargar las notificaciones.</p>
          <button (click)="resetAndLoadList()">Reintentar</button>
        </div>
      }

      <!-- Table -->
      @if (!listLoading && !listError) {
        @if (listItems.length === 0) {
          <div class="empty-state">
            <p>No hay notificaciones con los filtros aplicados.</p>
          </div>
        }

        @if (listItems.length > 0) {
          <div class="table-wrapper">
            <table class="history-table notif-list-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Título</th>
                  <th>Estado</th>
                  <th>Fecha lectura</th>
                </tr>
              </thead>
              <tbody>
                @for (n of listItems; track n.id) {
                  <tr>
                    <td class="date-cell">{{ formatDate(n.creationDate) }}</td>
                    <td class="user-cell">
                      @if (n.userName) {
                        <span class="user-name">{{ n.userName }}</span>
                      }
                      @if (n.userEmail) {
                        <span class="user-email">{{ n.userEmail }}</span>
                      }
                      <span class="user-uid">{{ n.owner }}</span>
                    </td>
                    <td class="title-cell">{{ n.title }}</td>
                    <td class="status-cell">
                      @if (n.read) {
                        <span class="badge badge--read">Leída</span>
                      } @else {
                        <span class="badge badge--unread">No leída</span>
                      }
                    </td>
                    <td class="date-cell">
                      {{ n.readDate ? formatDate(n.readDate) : '—' }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="pagination">
            <button class="btn btn--ghost" (click)="listPrevPage()" [disabled]="!listHasPrevPage">
              ← Anterior
            </button>
            <span class="page-info">Página {{ listCurrentPage + 1 }}</span>
            <button class="btn btn--ghost" (click)="listNextPage()" [disabled]="!listHasNextPage">
              Siguiente →
            </button>
          </div>
        }
      }

    </div>
  }

</div>
